import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LoanCheckUI from '../../../components/superUser/loan/assessment/LoanCheckUI'
import LoanSizingUI from '../../../components/superUser/loan/assessment/LoanSizingUI'
import LoanSizingCalcUI from '../../../components/superUser/loan/assessment/LoanSizingCalcUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const LoanSizingPageUI = ({ context, errorList, loan, loanCheckList, loanSizingClassicList, loanSizingSmallList,
  provisionalYear, onRefreshClick,
  showAllYears, onShowAllClick, onShowRecentClick,
  updateRemarksMode, onCancelRemarksClick, objectCode, objectId, objectFlavor, selectedRemarks, onUpdateRemarksClick,
  onShowDetails, showDetailsMode, toggleEditable, editable,
  loanSizing2, loanSizingSmall2, selectedloanClassic2Remarks
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_siz' topnav='loans'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !loanSizing2 && !loanSizingSmall2} loan={loan} page='sizing'
    dimension='w768'
  >
    {
      (!loan || !errorList || !loanSizing2 && !loanSizingSmall2) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loanSizing2 && loanSizingSmall2 &&
      <LoanSizingCalcUI
        context={context}
        loan={loan}
        onRefreshClick={onRefreshClick}
        sizing={true}
        onUpdateRemarksClick={onUpdateRemarksClick}
        updateRemarksMode={updateRemarksMode}
        onCancelRemarksClick={onCancelRemarksClick}
        objectCode={objectCode}
        objectId={objectId}
        selectedloanClassic2Remarks={selectedloanClassic2Remarks}
        onShowDetails={onShowDetails}
        showDetailsMode={showDetailsMode}
        toggleEditable={toggleEditable}
        editable={editable}
        loanSizing2={loanSizing2}
        loanSizingSmall2={loanSizingSmall2}
      />
    }

    {
      false &&  loanSizingClassicList && loanSizingSmallList &&
      <LoanSizingUI
        context={context}
        loan={loan}
        loanFlavor='classic'
        loanSizingList={loanSizingClassicList}
        provisionalYear={provisionalYear}
        onRefreshClick={onRefreshClick}
        showAllYears={showAllYears}
        onShowAllClick={onShowAllClick}
        onShowRecentClick={onShowRecentClick}
        sizing={true}
        onUpdateRemarksClick={onUpdateRemarksClick}
        updateRemarksMode={updateRemarksMode}
        onCancelRemarksClick={onCancelRemarksClick}
        objectCode={objectCode}
        objectId={objectId}
        objectFlavor={objectFlavor}
        selectedRemarks={selectedRemarks}
        onShowDetails={onShowDetails}
        showDetailsMode={showDetailsMode}
        toggleEditable={toggleEditable}
        editable={editable}
      />
    }
    <div className='g_m_top_200' />
    {
      false && loanSizingClassicList && loanSizingSmallList &&
      <LoanSizingUI
        context={context}
        loan={loan}
        loanFlavor='small'
        loanSizingList={loanSizingSmallList}
        provisionalYear={provisionalYear}
        onRefreshClick={onRefreshClick}
        showAllYears={showAllYears}
        onShowAllClick={onShowAllClick}
        onShowRecentClick={onShowRecentClick}
        sizing={true}
        onUpdateRemarksClick={onUpdateRemarksClick}
        updateRemarksMode={updateRemarksMode}
        onCancelRemarksClick={onCancelRemarksClick}
        objectCode={objectCode}
        objectId={objectId}
        objectFlavor={objectFlavor}
        selectedRemarks={selectedRemarks}
        onShowDetails={onShowDetails}
        showDetailsMode={showDetailsMode}
        toggleEditable={toggleEditable}
        editable={editable}
      />
    }
    <div className='g_m_top_200' />
    {
      false && loanCheckList &&
      <LoanCheckUI
        context={context}
        loanSizingList={loanCheckList}
        provisionalYear={provisionalYear}
        onRefreshClick={onRefreshClick}
        showAllYears={showAllYears}
        onShowAllClick={onShowAllClick}
        onShowRecentClick={onShowRecentClick}
        sizing={false}
        onShowDetails={onShowDetails}
        showDetailsMode={showDetailsMode}
        toggleEditable={toggleEditable}
        editable={editable}
      />
    }

  </SuperUserLoanPageUI>

export default LoanSizingPageUI
